import api from '../../store/config/api';
import {
  NOTIFICATION as SCHEMA,
  NOTIFICATION_LIST as SCHEMA_LIST
} from '../../schemas';

export const [
  GET_NOTIFICATIONS,
  GET_NOTIFICATIONS_REQUEST,
  GET_NOTIFICATIONS_SUCCESS,
  GET_NOTIFICATIONS_FAILURE
] = api.buildTypes('GET_NOTIFICATIONS');

export function getNotifications({ teamName, username, read }) {
  return {
    type: GET_NOTIFICATIONS,
    payload: {
      url: `teams/${teamName}/users/${username}/notifications?read=${read}`,
      schema: SCHEMA_LIST,
      options: {
        method: 'GET'
      }
    }
  };
}

export const [
  UPDATE_NOTIFICATION,
  UPDATE_NOTIFICATION_REQUEST,
  UPDATE_NOTIFICATION_SUCCESS,
  UPDATE_NOTIFICATION_FAILURE
] = api.buildTypes('UPDATE_NOTIFICATION');

export function updateNotification({
  teamName,
  username,
  notificationID,
  notification
}) {
  return {
    type: UPDATE_NOTIFICATION,
    payload: {
      url: `teams/${teamName}/users/${username}/notifications/${notificationID}`,
      schema: SCHEMA,
      options: {
        method: 'PUT',
        body: notification
      }
    }
  };
}

export const [
  READ_NOTIFICATION,
  READ_NOTIFICATION_REQUEST,
  READ_NOTIFICATION_SUCCESS,
  READ_NOTIFICATION_FAILURE
] = api.buildTypes('READ_NOTIFICATION');

export function readNotification({ teamName, username, notificationID }) {
  return {
    type: READ_NOTIFICATION,
    payload: {
      url: `teams/${teamName}/users/${username}/notifications/${notificationID}`,
      schema: SCHEMA,
      options: {
        method: 'PUT',
        body: { read: true }
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/notifications.js